import React from "react";
import { ContentCategoryType } from "../../../controller/MasterController";

interface CategoryProps {
  item: ContentCategoryType;
  navigateSector: any;
}

const CategoryContent = ({ item, navigateSector }: CategoryProps) => {
  return (
    <div className="storeItem" onClick={() => navigateSector(item.data, -1)}>
      <img className="titleImg" src={`${item.data.category_url}`} />
      <div className="itemContent">
        <p>{item.data.category_name}</p>
      </div>
    </div>
  );
};
export default CategoryContent;
